/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Event_Group_CreatedInputs */



/**
* | output |
* | --- |
* | "A new event group has been created using the selected marker list" |
*
* @param {Markers_Event_Group_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_event_group_created = /** @type {((inputs?: Markers_Event_Group_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Event_Group_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un nouveau groupe d'evenements a ete cree a partir de la liste de marqueurs selectionnee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurde eine neue Ereignisgruppe anhand der ausgewählten Markerliste erstellt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("È stato creato un nuovo gruppo di eventi utilizzando l'elenco dei marcatori selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создана новая группа событий с использованием выбранного списка маркеров.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se ha creado un nuevo grupo de eventos utilizando la lista de marcadores seleccionada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已使用选定的标记列表创建了一个新的事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したマーカーリストを使用して新しいイベントグループが作成されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित मार्कर सूची का उपयोग करके एक नया इवेंट समूह बनाया गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Um novo grupo de eventos foi criado usando a lista de marcadores selecionada.")
	return /** @type {LocalizedString} */ ("A new event group has been created using the selected marker list")
});